<script>
    import facets from '/srv/web/wyvr/html/releases/58819/gen/client/shop/config/facets.js?1733898724921';
    import { onMount, createEventDispatcher } from 'svelte';

    import { get_filter_options } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/category/filter_products.js?1733898724921';
    import FacetBool from '/srv/web/wyvr/html/releases/58819/gen/client/shop/facet/block/FacetBool.svelte?1733898724921';
    import FacetList from '/srv/web/wyvr/html/releases/58819/gen/client/shop/facet/block/FacetList.svelte?1733898724921';
    import FacetSlider from '/srv/web/wyvr/html/releases/58819/gen/client/shop/facet/block/FacetSlider.svelte?1733898724921';
    import CategoryFacet from '/srv/web/wyvr/html/releases/58819/gen/client/shop/facet/block/CategoryFacet.svelte?1733898724921';
    import { get_code_of_attribute, get_data_of_attribute } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/facet/facet_helper.js?1733898724921';

    export let filter = {};
    export let products = [];

    const dispatch = createEventDispatcher();
    //$: update(products);

    let options = undefined;
    let max = 0;
    let details = {};
    let category_facet;
    let timer;
    $: {
        update_debounce(products);
    }

    function update_debounce(products) {
        clearTimeout(timer);
        timer = setTimeout(() => {
            update(products);

            const cf = getStack('category_facet');
            if (cf) {
                category_facet = cf.map((childCategory) => filterCategory(childCategory, products)).filter(Boolean);
            }
        }, 250);
    }
    ;

    function transformCategories(categories) {
        return categories.map((category) => {
            let transformedCategory = {
                key: category.name,
                value: category.entity_id,
            };

            if (category.children) {
                transformedCategory.children = transformCategories(category.children);
            }

            return transformedCategory;
        });
    }

    function filterCategory(category) {
        if (!category.value) {
            console.warn(category);
        }
        const isCategoryInProduct = products.some((product) => {
            if (product.category_ids.value) {
                return product.category_ids.value.includes(category.value.toString());
            }
            return false;
        });

        if (!isCategoryInProduct) {
            return null;
        }

        if (!category.key || !category.value) {
            // Achtung! Geändert von name/entity_id zu key/value
            return null;
        }

        let result = {
            key: category.key,
            value: category.value,
        };

        if (category.children) {
            const filteredChildren = category.children
                .map((childCategory) => filterCategory(childCategory, products))
                .filter(Boolean);
            if (filteredChildren.length > 0) {
                result.children = filteredChildren;
            }
        }

        return result;
    }

    onMount(() => {
        update(products);
        category_facet = getStack('category_facet');
    });

    function update(products) {
        max = products.length;
        setTimeout(() => {
            options = get_options();
        }, 0);
    }
    function get_options() {
        return get_filter_options(facets.attributes, products);
    }
    function update_details(data) {
        const new_details = {};
        Object.keys(filter).forEach((key) => {
            new_details[key] = details[key];
            if (data.key == key) {
                new_details[key] = data.details;
            }
        });
        details = new_details;
        dispatch('details', details);
    }
</script>

{#if options}
    <section>
        {#each facets.attributes as entry}
            {@const code = get_code_of_attribute(entry)}
            {@const data = get_data_of_attribute(options, code)}

            {#if data !== undefined}
                {#if entry.type == 'tree'}
                    {#if category_facet && category_facet.length}
                        <CategoryFacet
                            name={code}
                            bind:value={filter[code]}
                            headline={window.__(entry.name)}
                            list={category_facet}
                            amount={data[0].skus.length}
                            categories={category_facet}
                            on:details={(e) => update_details(e.detail)}
                        />
                    {/if}
                {:else if entry.type == 'bool'}
                    <FacetBool
                        name={code}
                        bind:value={filter[code]}
                        headline={window.__(entry.name)}
                        amount={data[0].skus.length}
                        {max}
                    />
                {:else if entry.type == 'list'}
                    <FacetList
                        name={code}
                        bind:value={filter[code]}
                        headline={window.__(entry.name)}
                        list={data}
                        min={facets.min_entries}
                        on:details={(e) => update_details(e.detail)}
                    />
                {:else if entry.type == 'slider'}
                    <FacetSlider
                        name={code}
                        bind:value={filter[code]}
                        headline={window.__(entry.name)}
                        list={data}
                        step={entry.step ? entry.step : 1}
                        unit={entry.unit}
                    />
                {/if}
            {/if}
        {/each}
    </section>
{/if}

<!-- <b>options</b>
<pre>{JSON.stringify(options, null, 4)}</pre> -->

<!-- <b>filter</b>
<pre>{JSON.stringify(filter, null, 4)}</pre> -->

<!-- <b>facets.attributes</b>
<pre>{JSON.stringify(facets.attributes, null, 4)}</pre> -->
<style>section {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 15px;
    background: var(--lightbrown);
    padding: 15px 30px;
}
@media (max-width: 992px) {
    section {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media (max-width: 640px) {
    section {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 480px) {
    section {
        grid-template-columns: repeat(1, 1fr);
    }
}
</style>